import { render, staticRenderFns } from "./BaseSideNavigation.vue?vue&type=template&id=4d834d72&scoped=true"
import script from "./BaseSideNavigation.vue?vue&type=script&lang=js"
export * from "./BaseSideNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d834d72",
  null
  
)

export default component.exports